import React from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Container
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import HomeIcon from '@mui/icons-material/Home';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import EmailIcon from '@mui/icons-material/Email';
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import InfoIcon from '@mui/icons-material/Info';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

import { Link } from 'react-router-dom';
import HeaderProfile from './HeaderProfile';
import { useAuth } from '../../modules/auth/AuthContext';
import { useNavigate } from 'react-router-dom';

function Header() {
  const { isLoggedIn } = useAuth();

  const navigate = useNavigate();
  const handleProfile = () => {
    navigate('/profile');
  }
  const handleMyPlan = () => {
    navigate('/myplan');
  }
  const handleLogout = () => {
    navigate('/logout');
  };

  const pages = isLoggedIn ? [
    { name: 'Home', icon: <HomeIcon /> },
    { name: 'About', icon: <InfoIcon /> },
    { name: 'Contact', icon: <EmailIcon /> },
    // ... 他のログイン時のページとアイコン
  ] : [
    { name: 'Home', icon: <HomeIcon /> },
    { name: 'Login', icon: <LoginIcon /> },
    { name: 'About', icon: <InfoIcon /> },
    { name: 'Contact', icon: <EmailIcon /> },
    // ... 他の非ログイン時のページとアイコン
  ];
  const settings = isLoggedIn && [
    { name: 'Profile', icon: <AccountBoxIcon />, action: handleProfile },
    { name: 'MyPlan', icon: <FolderSharedIcon />, action: handleMyPlan },
    { name: 'Logout', icon: <LogoutIcon />, action: handleLogout },
  ];

  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const drawer = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column', // 子要素を縦に並べる
        justifyContent: 'space-between', // 上部のロゴと下部のプロフィールを最大限離す
        height: '100vh', // ビューポートの高さに合わせる
      }}
      onClick={handleDrawerToggle}
    >
      <Box sx={{ textAlign: 'center' }}>
        <Link to="/">
          <img src="/images/logo.png" alt="説明" style={{ width: '80%', margin: '25px 0px 5px 0px' }} />
        </Link>
        <List>
          {pages.map((page) => (
            <ListItem
              key={page.name}
              button
              component={Link}
              to={`/${page.name.toLowerCase()}`}
              style={{ marginTop: '0' }}
            >
              <ListItemIcon style={{ color: '#b3b3b3', minWidth: '45px', marginLeft: 10, }}>{page.icon}</ListItemIcon>
              <ListItemText style={{ fontWeight: 'bold' }} primary={page.name} />
            </ListItem>
          ))}
        </List>
      </Box>
      <Box sx={{ textAlign: 'left', mb: 2 }}>
        {isLoggedIn && <HeaderProfile settings={settings}/>}
      </Box>
    </Box>
  );

  return (

    <div className="header">
      <AppBar
        position="static"
        style={{ background: 'black' }}
        sx={{
          display: 'flex', // デフォルトは表示
          '@media (min-width:1200px)': {
            display: 'none', // 900px以上で非表示
          },
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters sx={{ display: 'flex', padding: '5px 0px' }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{ display: { sm: 'none', md: 'none', } }}
            >
              <MenuIcon />
            </IconButton>
            <Link to="/" style={{ textAlign: 'center' }}>
            <img src="/images/logo_sp1.png" alt="説明" style={{ width: '45%'}} />
            </Link>
            {/* The rest of your AppBar code */}
          </Toolbar>
        </Container>
      </AppBar>
      <Box component="nav">
        {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 250, background: '#000', color: 'white', },
          }}
        >
          {drawer}
        </Drawer>
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 200, color: 'white', background: 'black', },
          }}
          open
        >
          {drawer}
        </Drawer>
      </Box>
      {/* The rest of your content */}
    </div>
  );
}

export default Header;
